module.exports = __webpack_public_path__ + "static/img/right.9808451.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/right.png
// module id = wF+L
// module chunks = 1